import { useMsal } from "@azure/msal-react";

export function getUserName() {
  const { accounts } = useMsal();
  return accounts[0].username;
}
